import { Controller } from '@hotwired/stimulus'

export default class extends Controller {

  connect() {
    // Hide toolbar immediately to prevent flash
    this.hideToolbars()

    // Also hide on trix-initialize in case toolbar is added later
    document.addEventListener('trix-initialize', this.handleTrixInitialize.bind(this), { once: true })
  }

  hideToolbars() {
    if (document.querySelectorAll('trix-toolbar').length > 0) {
      document.querySelectorAll('trix-toolbar').forEach((toolbar) => {
        toolbar.style.display = 'none'
      })
    }
  }

  handleTrixInitialize() {
    this.hideToolbars()
  }
}
